import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsDiameterOuterSizeS from './IconToolsDiameterOuter_size_s';

const props: CreateIconArguments = {
  l: IconToolsDiameterOuterSizeS,
  m: IconToolsDiameterOuterSizeS,
  s: IconToolsDiameterOuterSizeS,
  xs: IconToolsDiameterOuterSizeS,
  name: 'IconToolsDiameterOuter',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
